import type ISchoolRepository from '@/core/domain/school/core/ISchoolRepository'
import School, { SchoolInput } from '@/core/domain/school/core/School'

export default class CreateSchoolUseCase {
  private schoolRepository: ISchoolRepository

  constructor(schoolRepository: ISchoolRepository) {
    this.schoolRepository = schoolRepository
  }

  async execute(school: SchoolInput): Promise<School> {
    return await this.schoolRepository.createSchool(school)
  }
}
